// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2m47J","top":"styles_top__zUmV1"};